import React, {createContext, useContext, useEffect, useState} from "react";
import Cookies from 'js-cookie';

type CookiesType = {
    accepted: boolean | undefined;
    acceptedAnalytics: boolean;
};

const CookiesContext = createContext<CookiesType>({
    accepted: undefined,
    acceptedAnalytics: false,
});

export const useCookies = () => useContext(CookiesContext);

export const CookiesProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
    const [accepted, setAccepted] = useState<boolean | undefined>(false);
    const [acceptedAnalytics, setAcceptedAnalytics] = useState(false);

    async function loadInfo() {
        if(Cookies.get("cookiesAccepted") === "true")
            setAccepted(true);
        else if(Cookies.get("cookiesAccepted") === "false")
            setAccepted(false);
        else
            setAccepted(undefined);

        if(Cookies.get("cookiesAnalytics") === "true")
            setAcceptedAnalytics(true);
        else
            setAcceptedAnalytics(false);
    }

    useEffect(() => {
        loadInfo();
    }, []);

    return (
        <CookiesContext.Provider value={{accepted, acceptedAnalytics}}>
            {children}
        </CookiesContext.Provider>
    );
};